// @flow

export { default, statuses } from "./CustomerStatusChip";
